/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Array$from = _interopDefault(require('babel-runtime/core-js/array/from'));
var __ol__ = _interopDefault(require('openlayers'));
var minilo = require('../util/minilo');
var tileSource = _interopDefault(require('../mixin/tile-source'));
var consts = require('../ol-ext/consts');
var extent = require('../ol-ext/extent');
var tileGrid = require('../ol-ext/tile-grid');
var assert = require('../util/assert');
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));

var WMTSSource = __ol__.source.WMTS;
var WMTSTileGrid = __ol__.tilegrid.WMTS;
var props = {
  dimensions: Object,
  format: {
    type: String,
    default: consts.WMTS_FORMAT
  },
  layerName: {
    type: String,
    required: true
  },
  matrixSet: {
    type: String,
    required: true
  },
  requestEncoding: {
    type: String,
    default: consts.WMTS_REQUEST_ENCODING
  },
  styleName: {
    type: String,
    required: true
  },
  version: {
    type: String,
    default: consts.WMTS_VERSION
  },
  url: {
    type: String,
    required: true
  }
};

var methods = {
  /**
   * @returns {ol.source.WMTS}
   * @protected
   */
  createSource: function createSource() {
    return new WMTSSource({
      attributions: this.attributions,
      cacheSize: this.cacheSize,
      crossOrigin: this.crossOrigin,
      dimensions: this.dimensions,
      format: this.format,
      layer: this.layerName,
      logo: this.logo,
      matrixSet: this.matrixSet,
      projection: this.projection,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      requestEncoding: this.requestEncoding,
      tileGrid: this._tileGrid,
      tilePixelRatio: this.tilePixelRatio,
      style: this.styleName,
      version: this.version,
      url: this.urlTmpl,
      wrapX: this.wrapX,
      transition: this.transition,
      tileLoadFunction: this.tileLoadFunction
    });
  },

  /**
   * @return {ol.tilegrid.WMTS}
   * @protected
   */
  createTileGrid: function createTileGrid() {
    assert.hasView(this);

    var extent$$1 = extent.createExtentFromProjection(this.$view.getProjection());
    var resolutions = tileGrid.resolutionsFromExtent(extent$$1, this.maxZoom, this.tileSize);

    return new WMTSTileGrid({
      extent: extent$$1,
      resolutions: resolutions,
      tileSize: this.tileSize,
      minZoom: this.minZoom,
      matrixIds: _Array$from(minilo.range(this.minZoom, resolutions.length))
    });
  }
};

var Source = {
  name: 'vl-source-wmts',
  mixins: [tileSource],
  props: props,
  methods: methods
};

/**
 * @alias module:wmts-source
 */
var index = {
  /**
   * @alias module:wmts-source/source
   */
  Source: Source,
  /**
   * @param {Vue} Vue
   * @param {VueLayersOptions} [options]
   */
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    options = minilo.pick(options, 'dataProjection');
    _Object$assign(Source, options);

    Vue.component(Source.name, Source);
  }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/wmts-source/index.js
// module id = 1499
// module chunks = 1